import { useState } from 'react';
import { CaretDown, ArrowRight } from '@phosphor-icons/react';

const CALENDLY = 'https://calendly.com/tanner-sv/30';

const CATEGORIES = [
  {
    title: 'D2C Fulfillment', image: '/lp/WarehouseImagery/[5]_Shipping_&_Delivery/IMPORT EXPORT.jpg',
    description: 'From branded packaging to lightning-fast delivery, we handle the D2C logistics that build customer loyalty and drive repeat purchases. Our team has generated multiple 8-figures in Shopify revenue — Ship Velocity is built for founders, by founders.',
    bullets: ['1-3 day nationwide shipping with intelligent route optimization', 'Custom branded packaging & memorable unboxing experiences', 'Real-time inventory sync across all your sales channels', 'Seamless returns handling built around your brand'],
  },
  {
    title: 'Amazon FBA Prep', image: '/lp/FBA_Compliance/image.png',
    description: "Navigate Amazon's complex requirements with ease. Our team are experts in Amazon's ever-changing standards, ensuring your inventory is accepted every time — no rejections, no penalties, no delays.",
    bullets: ['FNSKU labeling, poly bagging & suffocation warnings', '100% FBA compliant — inspection, bundling, labeling, shipping', 'Carton weight & dimension limit compliance', 'Direct coordination with Amazon preferred carriers'],
  },
  {
    title: 'Wholesale & Retail', image: '/lp/WarehouseImagery/[3]_Order_Processing/Order_processing_1.jpg',
    description: 'EDI-compliant B2B logistics for retail and wholesale distribution at scale. We handle the complexity of retailer requirements so you can focus on growing your wholesale channel.',
    bullets: ['EDI-compliant order processing & routing', 'Retailer-specific packaging & labeling requirements', 'Pallet building, shrink wrapping & floor-ready displays', 'Scalable infrastructure for large volume B2B orders'],
  },
  {
    title: 'Subscription Boxes', image: '/lp/WarehouseImagery/[4]_Packaging_&_Customization/EXPORT 8.jpg',
    description: 'Assembly, kitting, and shipping for subscription-based products. We handle seasonal surges and complex kitting requirements so every box arrives perfectly curated.',
    bullets: ['Custom kitting & assembly for unique box configurations', 'Seasonal surge capacity — scale up without missing a beat', 'Insert management & personalized packaging options', 'Recurring order automation & inventory forecasting'],
  },
];

export default function IndustriesServed() {
  const [openIdx, setOpenIdx] = useState(0);
  const active = CATEGORIES[openIdx >= 0 ? openIdx : 0];

  return (
    <section id="services" data-testid="industries-section" className="py-14 sm:py-20 lg:py-28" style={{ background: 'linear-gradient(180deg, #191E29, #132D46 50%, #191E29)' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight">
            Specialized fulfillment for <span className="text-[#07c28e]">every need</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-14">
          <div className="lg:col-span-3 space-y-0">
            {CATEGORIES.map((cat, i) => {
              const isOpen = openIdx === i;
              return (
                <div key={cat.title} data-testid={`industry-${cat.title.toLowerCase().replace(/\s+/g, '-')}`} className="border-b border-white/10">
                  <button onClick={() => setOpenIdx(isOpen ? -1 : i)} className="w-full flex items-center justify-between py-5 text-left group">
                    <span className={`text-lg font-bold transition-colors ${isOpen ? 'text-[#07c28e]' : 'text-white/70 group-hover:text-[#07c28e]'}`}>{cat.title}</span>
                    <CaretDown size={20} className={`text-white/30 transition-transform duration-300 ${isOpen ? 'rotate-180 text-[#07c28e]' : ''}`} />
                  </button>
                  <div className={`accordion-content ${isOpen ? 'open' : ''}`}>
                    <div className="pb-6 space-y-4">
                      <p className="text-sm text-white/40 leading-relaxed">{cat.description}</p>
                      <ul className="space-y-2">
                        {cat.bullets.map((b, j) => (
                          <li key={j} className="flex items-start gap-2 text-sm text-white/50">
                            <span className="text-[#07c28e] font-bold mt-0.5">&#x2022;</span>{b}
                          </li>
                        ))}
                      </ul>
            <a href={CALENDLY} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#07c28e] text-white text-sm font-semibold rounded-full hover:bg-[#06a879] transition-colors mt-2"
                      onClick={(e) => { e.preventDefault(); document.getElementById('hero')?.scrollIntoView({ behavior: 'smooth' }); }}>
                        Get pricing <ArrowRight size={14} weight="bold" />
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="lg:col-span-2 flex flex-col items-center justify-start">
            {active.image ? (
              <div className="w-full rounded-2xl overflow-hidden mb-6 border border-white/10">
                <img src={active.image} alt={active.title} className="w-full h-[320px] object-cover" />
              </div>
            ) : (
              <div className="w-full h-[320px] rounded-2xl bg-[#132D46] flex items-center justify-center mb-6 border border-white/10">
                <span className="text-white/20 text-sm">Coming soon</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
